import vue from 'vue'

export default {
  visitorMode: true,
  GeoKeys: '5Y6BZ-VLPEI-SJ5GP-ULXI2-2JDIK-D6FTJ',
  primaryColor: '#F03867',
  tokenName: '福贝'
}

vue.prototype.$config = {
  tokenName: '福贝'
}
